import App from 'app/app.js';

function LtSelectFocusDirective($timeout, $window, $document) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var unwatch = scope.$watch(attrs.ltSelectFocus, function () {
        if (scope.isIOS()) {
          scope.$evalAsync(function () {
            if (scope.$eval(attrs.ltSelectFocus)) {
              scope.focusElement();
            }
          });
        } else {
          $timeout(function () {
            if (scope.$eval(attrs.ltSelectFocus)) {
              scope.createMouseEvent();
            }
          });
        }
      });

      scope.createMouseEvent = function () {
        if ($document.context.createEvent) {
          // Creates a mouse event object.
          var event = $document.context.createEvent('MouseEvents');
          // Initializes the value of a mouse event object with event type 'mousedown'.
          event.initMouseEvent('mousedown', true, true, $window);
          element[0].dispatchEvent(event);
        }
      };

      scope.focusElement = function () {
        element[0].focus();
      };

      scope.isIOS = function () {
        return /iPad|iPhone|iPod/.test($window.navigator.platform);
      };

      scope.$on('$destroy', function () {
        unwatch();
      });
    }
  };
}

App.directive('ltSelectFocus', ['$timeout', '$window', '$document', LtSelectFocusDirective]);
